import React from "react";
import { Button } from "@mui/material";

const StatusBadge = ({ status }) => {
  const getButtonStyles = (status) => {
    const isOutlined = true;
    if (status === "Cancel Booking") {
      return {
        backgroundColor: isOutlined ? "transparent" : "red",
        color: isOutlined ? "red" : "#fff",
        borderColor: "red",
      };
    } else if (status === "Pending") {
      return {
        backgroundColor: "#FFCC0033",
        color: "#FFCC00",
        borderColor: "#FFCC00",
      };
    } else if (status === "Upcoming" || status === "Completed" || status === "Paid") {
      return {
        backgroundColor: "#C8FFC3",
        color: "#128808",
        borderColor: "#128808",
      };
    } else if (status === "Rejected") {
      return {
        backgroundColor: isOutlined ? "transparent" : "red",
        color: isOutlined ? "red" : "#fff",
        borderColor: "red",
      };
    } else if (status === "Cancelled") {
      return {
        backgroundColor: "#FFB6B6",
        color: "#FF0000",
        borderColor: "#FF0000",
      };
    } else if (status === "Timed out") {
      return {
        backgroundColor: "#FFD0A5",
        color: "#FF7900",
        borderColor: "#FF7900",
      };
    } else {
      return {};
    }
  };

  return (
    <Button
      variant={"outlined"}
      sx={{
        ...getButtonStyles(status),
        fontWeight: "700",
        textTransform: "capitalize",
        fontSize: "16px"
      }}
    >
      {status === "Paid" ? "Completed" : status}
    </Button>
  );
};

export default StatusBadge;
